import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import StatusBadge from '../shared/StatusBadge';

const ConvertModal = ({ isOpen, onClose, onSave, enquiry, plans }) => {
    const [planId, setPlanId] = useState('');
    const [accessType, setAccessType] = useState('RFID');
    const [paymentAmount, setPaymentAmount] = useState(0);

    useEffect(() => {
        if (isOpen && plans.length > 0) {
            const activePlans = plans.filter(p => p.status === 'active');
            const initialPlan = activePlans[0];
            setPlanId(initialPlan?.id || '');
            setPaymentAmount(initialPlan?.price || 0);
        }
    }, [isOpen, plans]);

    useEffect(() => {
        const selectedPlan = plans.find(p => p.id === planId);
        if (selectedPlan) {
            setPaymentAmount(selectedPlan.price);
        }
    }, [planId, plans]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // if (!planId || paymentAmount < 0) {
        //     toast.error('Please select a plan and enter a valid payment amount.');
        //     return;
        // }
        onSave({
            planId,
            accessType,
            paymentAmount,
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Convert ${enquiry?.user_name} to Member`}>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6">

                        <div>
                            <p className="text-sm text-gray-500 font-medium">Name</p>
                            <p className="text-gray-800 font-semibold mt-1">{enquiry?.user_name || "-"}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500 font-medium">Contact</p>
                            <p className="text-gray-800 font-semibold mt-1">{enquiry?.phone || "-"}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500 font-medium">Email</p>
                            <p className="text-gray-800 font-semibold mt-1">{enquiry?.email || "-"}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500 font-medium">Source</p>
                            <p className="text-gray-800 font-semibold mt-1">{enquiry?.source || "-"}</p>
                        </div>

                        <div className="sm:col-span-2">
                            <p className="text-sm text-gray-500 font-medium">Remarks</p>
                            <p className="text-gray-800 mt-1">{enquiry?.remarks || "-"}</p>
                        </div>

                        <div className="sm:col-span-2">
                            <p className="text-sm text-gray-500 font-medium">Status</p>
                            <StatusBadge status={enquiry?.status} />
                        </div>

                    </div>
                </div>
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button type="submit" className="px-4 py-2 bg-brand-green text-white rounded-lg hover:bg-green-600">Confirm Conversion</button>
                </div>
            </form>
        </Modal>
    );
};

export default ConvertModal;
